import { globalAxios, backendVersion } from "@/axios-path.js";
// fetchFoodSetAppBack;
export default {
  namespaced: true,
  state: {
    province_th_list: [],
    maintenance_data: {},
    popup_data: {},
    notification_list: [],
    free_delivery_status: { status: false },
  },
  mutations: {
    resetState(state) {
      state.province_th_list = [];
      state.maintenance_data = {};
      state.popup_data = {};
      state.notification_list = [];
      state.free_delivery_status = { status: false };
    },
    getSubdistrictTH(state, data) {
      state.province_th_list = data;
    },
    getMaintenanceData(state, data) {
      state.maintenance_data = data;
    },
    getPopupData(state, data) {
      state.popup_data = data;
    },
    getNotificationList(state, data) {
      state.notification_list = data;
    },
    deleteNotificationLog(state, id) {
      let index = state.notification_list.findIndex(
        (val) => val.notification_inbox_id == id
      );
      state.notification_list.splice(index, 1);
    },
    getFreedeliveryStatus(state, status) {
      state.free_delivery_status = { status: status };
    },
  },
  actions: {
    async editBackListKeyword({}, payload) {
      // console.log(url)
      let form = {
        blacklist_area_keyword: payload.keyword,
      };
      let url = `/api/v1/${payload.province}/edit/BlacklistArea/${
        payload.keyword_id
      }`;
      return globalAxios
        .put(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async createBackListKeyword({}, payload) {
      // console.log(url)
      let form = {
        blacklist_area_keyword: payload.keyword,
      };
      let url = `/api/v1/${payload.province}/create/BlacklistArea`;
      return globalAxios
        .post(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async removeBackListKeyword({}, payload) {
      let url = `/api/v1/${payload.province}/delete/BlacklistArea/${
        payload.keyword_id
      }`;
      return globalAxios
        .delete(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getBackListKeywordList({}, payload) {
      // console.log(url)
      let url = `/api/v1/${payload.province}/show/BlacklistArea?page_size=${
        payload.page_size
      }&current_page=${payload.page}`;
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async editFreeDeliveryStatus(
      { rootState, dispatch, commit },
      { province_id, form }
    ) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_editFreeDeliveryStatus +
        province_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getFreeDeliveryStatus({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getFreeDeliveryStatus +
        province_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getFreedeliveryStatus", res.province_free_delivery);
        return true;
      }
    },
    async deleteNotificationLog({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/deleteInbox/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteNotificationLog", ID);
      }
      return res.msg ? res.msg : false;
    },
    async getNotificationList({ dispatch, commit }) {
      let url = backendVersion.version + "/getAllInbox";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getNotificationList", res.data);
      }
      return res;
    },
    async editNotificationContent({ dispatch, commit }, form) {
      let url = backendVersion.version + "/editInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async editNotificationBlog({ dispatch, commit }, form) {
      let url = backendVersion.version + "/editInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async sendNotification({ dispatch, commit }, form) {
      // Auto-generate blog if not provided
      if (!form.notification_inbox_html || form.notification_inbox_html.trim() === '') {
        form.notification_inbox_html = await dispatch('generateAutoBlog', form);
        form.notification_inbox_saved = true;
      }
      
      let url = backendVersion.version + "/createInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res.msg;
      }
    },
    generateAutoBlog({ rootState }, notificationData) {
      const { notification_inbox_title, notification_inbox_text } = notificationData;
      
      // Generate beautiful mobile-optimized HTML blog template using only inline styles
      const blogHtml = `
        <div style="font-family: 'Kanit', 'Sarabun', Arial, sans-serif; max-width: 600px; margin: 0 auto; background: linear-gradient(135deg, #fddf00 0%, #f4d03f 100%); border-radius: 12px; overflow: hidden; box-shadow: 0 15px 30px rgba(0,0,0,0.1);">
          <!-- Header Section -->
          <div style="background: rgba(255,255,255,0.15); backdrop-filter: blur(10px); padding: 20px 16px; text-align: center; border-bottom: 1px solid rgba(255,255,255,0.2);">
            <div style="display: inline-flex; background: #fff; border-radius: 50%; width: 56px; height: 56px; align-items: center; justify-content: center; margin-bottom: 14px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
              <span style="font-size: 24px; color: #333;">📢</span>
            </div>
            <h1 style="color: #2c3e50; font-size: 22px; font-weight: 600; margin: 0; text-shadow: 0 2px 4px rgba(255,255,255,0.3); line-height: 1.3; word-wrap: break-word; max-width: 95%; margin-left: auto; margin-right: auto;">
              ${notification_inbox_title || 'แจ้งเตือนสำคัญ'}
            </h1>
            <div style="height: 3px; width: 50px; background: #fff; margin: 14px auto; border-radius: 2px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"></div>
          </div>

          <!-- Content Section -->
          <div style="background: white; padding: 24px 18px;">
            <!-- Content Box -->
            <div style="background: linear-gradient(135deg, #fffef7 0%, #fff9e6 100%); border-radius: 14px; padding: 22px 18px; margin-bottom: 22px; border-left: 4px solid #fddf00; box-shadow: 0 4px 12px rgba(253, 223, 0, 0.1);">
              <h2 style="color: #2c3e50; font-size: 18px; margin: 0 0 14px 0; font-weight: 600; line-height: 1.4; display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 20px;">📋</span>
                <span>รายละเอียด</span>
              </h2>
              <div style="color: #34495e; line-height: 1.7; font-size: 15px; margin: 0; word-wrap: break-word; overflow-wrap: break-word; white-space: pre-wrap;">
                ${notification_inbox_text || 'ข้อมูลแจ้งเตือนจากระบบ WESERVE'}
              </div>
            </div>

            <!-- Footer Info -->
            <div style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 10px; padding: 20px 16px; text-align: center; margin-top: 22px; border: 1px solid rgba(0,0,0,0.05);">
              <div style="display: flex; align-items: center; justify-content: center; gap: 6px; margin-bottom: 10px;">
                <span style="font-size: 18px;">📱</span>
                <span style="color: #495057; font-size: 15px; font-weight: 500;">WESERVE</span>
              </div>
              <p style="color: #6c757d; font-size: 13px; margin: 0 0 6px 0; line-height: 1.5;">
                แพลตฟอร์มบริการครบวงจร
              </p>
              <p style="color: #868e96; font-size: 11px; margin: 0; line-height: 1.4;">
                ระบบแจ้งเตือนอัตโนมัติ • ${new Date().toLocaleDateString('th-TH', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>
          </div>

          <!-- Bottom Accent -->
          <div style="height: 6px; background: linear-gradient(90deg, #fddf00 0%, #f39c12 25%, #fddf00 50%, #f39c12 75%, #fddf00 100%);"></div>
        </div>
      `;
      
      return blogHtml;
    },
    async updatePopupData(
      { rootState, dispatch, commit },
      { province_id, form }
    ) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_updatePopupData + province_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getPopupData", res);
        return true;
      }
    },
    async getPopupData({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getPopupData + province_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getPopupData", res);
        return true;
      }
    },
    async updateMaintenaceData({ dispatch, commit }, form) {
      let url = backendVersion.version + "/fix_maintenance";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getMaintenanceData", res);
        return true;
      }
    },
    async getMaintenanceData({ dispatch, commit }) {
      let url = backendVersion.version + "/fix_maintenance";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getMaintenanceData", res);
        return true;
      }
    },
    async updateENSubdistrict({ rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_updateENSubdistrict +
        form.sub_district_province_id +
        "/" +
        form.sub_district_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getSubdistrictTH({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getSubdistrictTH + province_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getSubdistrictTH", res);
        return res;
      }
    },
    async changeStorePopular({ rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_changeStorePopular +
        form.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res.msg;
      }
    },
    async fetchPaymentMethodList({ rootState, dispatch }) {
       let url = '/api/v1/WeservePatmentOfmethod'
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async changePaymentMethodStatus({ rootState, dispatch }, payload) {
      let url = `/api/v1/WeservePatmentOfmethod/${payload.service_on_use_id}`;
      let form = JSON.parse(JSON.stringify(payload))
      delete form.service_on_use_id;
      return globalAxios
        .put(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {
    NotificationList(state) {
      return state.notification_list;
    },
  },
};
